import { useContext } from 'react';
import AuthenticatedRouteLanguageContext from './AuthenticatedRouteLanguageContext';
import UnauthenticatedRouteLanguageContext from './UnauthenticatedRouteLanguageContext';
import useIsAuthenticatedRoute from './useIsAuthenticatedRoute';

/**
 * Determine the language that should be used based on the route.
 * - Authenticated routes uses the language from the users profile.
 * - Unauthenticated routes uses the language store in localStorage.
 *
 * @return {string} language
 */
const useMessageLanguageByRoute = () => {
    const isAuthenticatedRoute = useIsAuthenticatedRoute();
    const { messageLanguage } = useContext(
        isAuthenticatedRoute
            ? AuthenticatedRouteLanguageContext
            : UnauthenticatedRouteLanguageContext,
    );
    return messageLanguage;
};

export default useMessageLanguageByRoute;
